import { getNumericQueryParameter, validateDate } from '@ama-selections/ui'
import { getNumericArrayQueryParameter } from '@ama-selections/ui/src/helpers/destination'
import { useEffect, useState } from 'react'
import { useSearchParams } from 'data/hooks/useSearchParams'

export interface PropertyFilters {
  arrival: string | null | undefined,
  departure: string | null | undefined,
  adults: number | undefined,
  children: number | undefined,
  bedrooms: number | undefined,
  bathrooms: number | undefined,
  search_categories: number[] | undefined,
  property_tag_types: number[] | undefined,
  minCost: number,
  maxCost: number,
}

const usePropertyFilters = () => {
  const { params } = useSearchParams()

  const [filters, setFilters] = useState<PropertyFilters>({
    arrival: null,
    departure: null,
    adults: undefined,
    children: undefined,
    bedrooms: undefined,
    bathrooms: undefined,
    search_categories: undefined,
    property_tag_types: undefined,
    minCost: 0,
    maxCost: 0,
  })

  useEffect(() => {
    setFilters({
      arrival: validateDate(params.get('arrival')) ? params.get('arrival') : null,
      departure: validateDate(params.get('departure')) ? params.get('departure') : null,
      adults: getNumericQueryParameter(params.get('adults')),
      children: getNumericQueryParameter(params.get('children')),
      bedrooms: getNumericQueryParameter(params.get('bedrooms')),
      bathrooms: getNumericQueryParameter(params.get('bathrooms')),
      search_categories: getNumericArrayQueryParameter(params.get('searchCategories')),
      property_tag_types: getNumericArrayQueryParameter(params.get('propertyTypes')),
      minCost: (getNumericQueryParameter(params.get('minimumPrice')) ?? 0) * 100,
      maxCost: (getNumericQueryParameter(params.get('maximumPrice')) ?? 0) * 100,
    })
  }, [params])

  return { filters }
}

export default usePropertyFilters
